import { Add } from "@mui/icons-material";
import {
  Button,
  Grid2 as Grid,
  Typography,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { ContentAccordion, PhoneField } from "src/shared/components";
import { validatePhone } from "src/shared/utils/hookFormRules";
import { contactBaseDefaultValue } from "../../model/constants";
import { IPartnerFormValues } from "../../model/types";
import { AddressBlock } from "./AddressBlock";
import { ContactItem } from "./ContactItem";

export const Contacts: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IPartnerFormValues>();
  const {
    fields: contactsFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "contact_persons",
  });

  const mainContactIndex = contactsFields.findIndex(
    ({ is_main_contact }) => is_main_contact,
  );

  const hasErrors = errors.contact_persons || errors.addresses;

  return (
    <ContentAccordion
      title={
        <Box display="flex" alignItems="center">
          <Chip label="5" />
          <Typography
            color={hasErrors ? "error" : "grey.500"}
            sx={{ ml: 2 }}
            component="span"
          >
            Контакты
          </Typography>
        </Box>
      }
    >
      <Grid container spacing={6}>
        <Grid size={12}>
          <Typography color="grey.500" fontSize="0.875rem">
            Основное контактное лицо
          </Typography>
        </Grid>
        {mainContactIndex > -1 && (
          <Grid size={12}>
            <ContactItem
              key={contactsFields[mainContactIndex]?.id}
              index={mainContactIndex}
            />
          </Grid>
        )}
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid size={12}>
          <Typography color="grey.500" fontSize="0.875rem">
            Дополнительные контактные лица
          </Typography>
        </Grid>
        {contactsFields.map((field, index) => {
          if (field.is_main_contact) return null;

          return (
            <Grid key={field.id} size={12}>
              <ContactItem index={index} remove={() => remove(index)} />
            </Grid>
          );
        })}
        <Grid size={12}>
          <Button
            variant="contained"
            onClick={() => append(contactBaseDefaultValue)}
            endIcon={<Add />}
          >
            Добавить
          </Button>
        </Grid>
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: 3 }}>
          <Controller
            control={control}
            name="partner.phone"
            render={({
              field: { ref, onChange, ...field },
              fieldState: { error },
            }) => (
              <PhoneField
                inputRef={ref}
                onChange={(_fieldValue, info) => {
                  onChange(info);
                }}
                {...field}
                label="Городской телефон"
                error={!!error}
                helperText={error?.message}
              />
            )}
            rules={{
              validate: (fieldValue) => validatePhone(fieldValue),
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: 3 }}>
          <Controller
            control={control}
            name="partner.fax"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <PhoneField
                inputRef={ref}
                {...field}
                label="Факс"
                error={!!error}
                helperText={error?.message}
              />
            )}
            rules={{
              validate: (fieldValue) => validatePhone(fieldValue),
            }}
          />
        </Grid>

        <Grid size={12}>
          <Box>
            <AddressBlock />
          </Box>
        </Grid>
      </Grid>
    </ContentAccordion>
  );
};
